/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShare = createReactComponent("share", "IconShare", [
  ["path", { d: "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M8.7 10.7l6.6 -3.4", key: "svg-3" }],
  ["path", { d: "M8.7 13.3l6.6 3.4", key: "svg-4" }]
]);

export { IconShare as default };
//# sourceMappingURL=IconShare.js.map
